// Inside a store app: the iPhone app (App Store, its bridge window.RoundlyIOS) or the Android app (Google Play,
// work.roundly.app, a Trusted Web Activity opening https://app.roundly.work/?app=android#/today). Neither store lets an
// app take payment or talk about prices outside its own billing (Apple 3.1.3, Google Play Payments policy), so inside
// either there is no Your plan, no trial words, no starting a round and no paying (docs/STORE-APPS.md). Only the
// iPhone app has the native bridge: features that need it still ask for window.RoundlyIOS itself.
const ANDROID_KEY = 'roundly-android-app'
const ANDROID_PACKAGE = 'work.roundly.app'

// Opened full screen (the app), never a Chrome tab: the app shares Chrome's storage, so the lasting mark only counts when
// the page fills the screen, as the app does and a Chrome tab never does. That covers the app reopened from a
// notification (public/sw.js opens the plain address, with no ?app=android and no referrer; Astra's store check).
const fullScreen = (): boolean => typeof matchMedia === 'function' && matchMedia('(display-mode: standalone)').matches

function noteAndroid(): boolean {
  if (typeof window === 'undefined') return false
  const fromApp = new URLSearchParams(window.location.search).get('app') === 'android' ||
    (typeof document !== 'undefined' && document.referrer.startsWith(`android-app://${ANDROID_PACKAGE}`))
  try {
    if (fromApp) { sessionStorage.setItem(ANDROID_KEY, '1'); localStorage.setItem(ANDROID_KEY, '1') }
    return fromApp || sessionStorage.getItem(ANDROID_KEY) === '1' || (localStorage.getItem(ANDROID_KEY) === '1' && fullScreen())
  } catch { return fromApp }
}

export function inAndroidApp(): boolean { return noteAndroid() }
export function inIPhoneApp(): boolean { return typeof window !== 'undefined' && 'RoundlyIOS' in window }
export function inStoreApp(): boolean { return inIPhoneApp() || inAndroidApp() }
// The Help request's own word for which store app asks (functions/lib/help.ts leaves out the paying answers for both).
export function storeAppParam(): string { return inIPhoneApp() ? '?app=ios' : inAndroidApp() ? '?app=android' : '' }
